import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/icons/class-teacher.png'
import _imports_1 from '@/assets/images/icons/spoon.png'
import _imports_2 from '@/assets/images/icons/group.png'


const _hoisted_1 = { class: "_analytics" }
const _hoisted_2 = { class: "shadow-sm sm:rounded-2xl overflow-hidden" }
const _hoisted_3 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_4 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_5 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_6 = { class: "bg-neutral-100 h-16" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-32 whitespace-nowrap"
}, " Tên học sinh ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
}, " Tuổi ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
}, " Kết quả học tập ", -1)
const _hoisted_10 = {
  key: 0,
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
}
const _hoisted_11 = {
  key: 1,
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "font-medium leading-none text-white text-xs" }
const _hoisted_17 = { class: "ml-4 text-orange-600 font-semibold whitespace-pre-wrap w-40" }
const _hoisted_18 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_19 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 0,
  class: "px-6 py-4 whitespace-nowrap text-neutral-700",
  style: {"min-width":"156px"}
}
const _hoisted_22 = { class: "flex items-center" }
const _hoisted_23 = {
  key: 0,
  class: "p-2"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5 h-5",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  class: "p-2"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5 h-5",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 2,
  class: "p-2"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5 h-5",
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("thead", _hoisted_6, [
              _createElementVNode("tr", null, [
                _hoisted_7,
                _hoisted_8,
                _hoisted_9,
                (!_ctx.isLitePackage)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_10, " Vai trò GV "))
                  : _createCommentVNode("", true),
                (!_ctx.isLitePackage)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_11, " Số dung lượng "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.studentList, (person, personIdx) => {
                return (_openBlock(), _createElementBlock("tr", {
                  onClick: ($event: any) => (
									_ctx.$router.push(`/record/student/${person.id}`)
								),
                  key: person.id,
                  class: _normalizeClass([
									personIdx % 2 === 0
										? 'bg-white'
										: 'bg-neutral-50'
								, "text-neutral-700 hover:bg-orange-50 cursor-pointer"])
                }, [
                  _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      (person?.profile_photo?.w200)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "shadow-sm inline-block h-6 w-6 rounded-full",
                            src: person?.profile_photo?.w200,
                            alt: ""
                          }, null, 8, _hoisted_15))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "inline-flex items-center justify-center h-6 w-6 rounded-full",
                            style: _normalizeStyle({
												background:
													person?.profile_photo
														?.default?.color,
											})
                          }, [
                            _createElementVNode("span", _hoisted_16, _toDisplayString(person?.profile_photo
														?.default?.initial), 1)
                          ], 4)),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(person.name), 1)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", null, _toDisplayString(person.age), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_19, [
                    (_ctx.assessment(person.id))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("div", {
                            class: "mt-1 py-0.5 px-2.5 rounded-full text-neutral-700 h-fit w-fit font-semibold text-xs shadow-input",
                            style: _normalizeStyle({
												background: _ctx.$filters.tagResult(
													_ctx.assessment(person.id)
														?.average_result
												)?.background,
												color: _ctx.$filters.tagResult(
													_ctx.assessment(person.id)
														?.average_result
												)?.color,
											})
                          }, _toDisplayString(_ctx.assessment(person.id)
													?.average_result) + "% ", 5)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.isLitePackage)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          (person?.has_personal_class)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                            : _createCommentVNode("", true),
                          (person?.has_day_care_class)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                            : _createCommentVNode("", true),
                          (person?.has_group_class)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isLitePackage)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", null, _toDisplayString(person.used_size), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_12))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}